<template>
    <div>
    <v-layout row align-baseline justify-start wrap>
        <v-flex grow style="padding-right: 0">
            <v-textarea readonly
                rows="1" :label="'Recorrência'" name="recurrence" :disabled="disabled"
                v-model="recurrenceText" @click="openRecurrence()" :messages="checkIsFree() ? 'Para usar a Recorrência, faça upgrade do seu plano' : ''"></v-textarea>
        </v-flex>
        <v-flex shrink>
          <p-btn-upgrade v-if="checkIsFree()"></p-btn-upgrade>
        </v-flex>
    </v-layout>
    <!-- recorrencia -->
      <v-dialog v-if="!disabled" v-model="recurrenceView" persistent max-width="800px">
        <v-form ref="form">
          <v-card>
            <v-card-title>
              <v-layout align-center justify-space-between>
                <span class="headline">Inclusão de Recorrência</span>
                <v-btn v-if="!checkIsFree()" @click="deleteAct" :disabled="disabled" outline color="pink">Excluir</v-btn>
              </v-layout>
            </v-card-title>
              <v-container fluid grid-list-xs>
              <v-layout row align-baseline justify-start wrap>
                <v-flex xs12>
                    <v-select
                      :id="id"
                      :items="['Diária', 'Semanal', 'Mensal', 'Anual']"
                      label="Padrão de Recorrência"
                      v-model="recurrence.type"
                      :rules="requiredRule('Padrão de Recorrência')"
                      @change="changeProcess()"
                    ></v-select>  
                </v-flex>
                <v-flex xs12 elevation-1 v-if="recurrence.type">
                  <h4 v-if="commitment">Data de início do compromisso:</h4>
                  <h4 v-else>Data da previsão da atividade:</h4>
                  <v-flex xs12>
                    <!-- Diario -->
                    <v-layout row align-baseline justify-start wrap v-if="recurrence.type==='Diária'">
                      <v-flex align-baseline justify-start xs2 sm1><span>A cada</span></v-flex>
                      <v-flex align-baseline justify-start xs2 sm1>
                      <v-text-field :rules="requiredRule('Dias')" @change="val => {(val < 1) ? recurrence.id_text.each = 1 : val}" type="number" min="1" v-model="recurrence.id_text.each"></v-text-field>
                      </v-flex>
                      <v-flex align-baseline justify-start xs1 sm2><span>Dia(s)</span></v-flex>
                      <strong></strong>
                    </v-layout>
                    <!-- Semanal -->
                    <v-layout row align-baseline justify-start wrap v-if="recurrence.type==='Semanal'">
                      <v-flex align-baseline justify-start xs2 sm1><span>Todo(a)</span></v-flex>
                      <v-flex align-baseline justify-start xs10 sm5>
                      <v-autocomplete
                          :items="translate('value.week_days')"
                          v-model="recurrence.id_text.days"
                          multiple
                          :rules="requiredRule('frequência')"
                      ></v-autocomplete>
                      </v-flex>
                      <v-flex align-baseline justify-start xs2 sm1><span>A cada</span></v-flex>
                      <v-flex align-baseline justify-start xs1>
                      <v-text-field :rules="requiredRule('Dias')" @change="val => recurrence.id_text.each = (val < 1) ? 1 : val" type="number" min="1" v-model="recurrence.id_text.each"></v-text-field>
                      </v-flex>
                      <v-flex align-baseline justify-start xs3><span>Semana(s).</span></v-flex>
                    </v-layout>
                    <!-- Mensal -->
                    <v-layout row align-baseline justify-start wrap v-if="recurrence.type==='Mensal'">
                      <v-flex align-baseline justify-start xs3 sm2><span>Todo(a) dia</span></v-flex>
                      <v-flex align-baseline justify-start xs1 sm1>
                      <v-text-field :rules="requiredRule('Dias')" @change="val => {monthDaysLimit(val)}" type="number" min="1" max="31" v-model="recurrence.id_text.days"></v-text-field>
                      </v-flex>
                      <v-flex align-baseline justify-start xs2 sm1><span>A cada</span></v-flex>
                      <v-flex align-baseline justify-start xs1>
                      <v-text-field :rules="requiredRule('Dias')" @change="val => recurrence.id_text.each = (val < 1) ? 1 : val" type="number" min="1" v-model="recurrence.id_text.each"></v-text-field>
                      </v-flex>
                      <v-flex align-baseline justify-start xs1><span>Mês(es).</span></v-flex>
                    </v-layout>
                    <!-- Anual -->
                    <v-layout row align-baseline justify-start wrap v-if="recurrence.type==='Anual'">
                      <v-flex align-baseline justify-start xs3 sm2><span>Todo(a) dia</span></v-flex>
                      <v-flex align-baseline justify-start xs1>
                      <v-text-field :rules="requiredRule('Dias')"  type="number" min="1" max="31" @change="(val) => {monthDaysLimit(val)}" v-model="recurrence.id_text.days"></v-text-field>
                      </v-flex>
                      <v-flex align-baseline justify-start xs1><span> de</span></v-flex>
                      <v-flex align-baseline justify-start xs3 sm5>
                      <v-autocomplete
                          :items="translate('value.months')"
                          label="Mês"
                          v-model="recurrence.id_text.months"
                          :rules="requiredRule('Mês')"
                      ></v-autocomplete>
                      </v-flex>
                      <v-flex align-baseline justify-start xs2 sm1><span>A cada</span></v-flex>
                      <v-flex align-baseline justify-start xs1 sm1>
                      <v-text-field :rules="requiredRule('Dias')" @change="val => recurrence.id_text.each = (val < 1) ? 1 : val" type="number" min="1" v-model="recurrence.id_text.each"></v-text-field>
                      </v-flex>
                      <v-flex align-baseline justify-start xs1><span>Ano(s).</span></v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- daysToCreate -->
                  <h4>Momento da criação:</h4>
                  <v-flex xs12>
                    <v-layout row align-baseline justify-start wrap v-if="recurrence.type!==''">
                    <v-flex align-baseline justify-start xs2 sm1><span>Criar</span></v-flex>
                    <v-flex align-baseline justify-start xs2 sm1>
                    <v-text-field :rules="requiredRule('Dias')" @change="val => recurrence.id_text.daysToCreate = val < 1 ? 1 : val" type="number" min="1" v-model="recurrence.id_text.daysToCreate"></v-text-field>
                    </v-flex>
                    <v-flex v-if="commitment" align-baseline justify-start xs8 sm10><span> Dias antes do início do compromisso.</span></v-flex>
                    <v-flex v-else align-baseline justify-start xs8 sm10><span> Dias antes da previsão da atividade.</span></v-flex>
                    </v-layout>
                  </v-flex>              
                </v-flex>              
                <strong v-if="recurrence.type==='Mensal' || recurrence.type==='Anual'">Se o dia ultrapassar o último dia do mês, irá ser criada a tarefa no último dia do mês.</strong>
              </v-layout>
              </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#00acc2" dark text @click="recurrenceConfirm">Salvar</v-btn>
              <v-btn color="#00acc2" dark text @click="recurDialogClose">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
</template>
<script>
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import mask from './../../mixin/mask'
  import PBtnUpgrade from './../shared/PBtnUpgrade'

  export default{
    mixins: [crud, rules, mask],
    components: {PBtnUpgrade},
    data: () => ({
      entity: 'recurrence',
      recurrence: {type: '', id_text: {each: '', days: '', months: '', daysToCreate: 1}},
      recurrenceView: false,
      days: '',
      beforeRecurOb: {type: '', id_text: {each: '', days: '', months: '', daysToCreate: 1}}
    }),
    props: {
      id: {
        default: 'task_recurrence'
      },
      // recurrence: {},
      value: {},
      recurrenceText: '',
      commitment: 0,
      disabled: false
    },
    methods: {
      openRecurrence () {
        if (this.value) {
          this.recurrence = JSON.parse(JSON.stringify(this.value))
        }
        this.beforeRecurOb = JSON.parse(JSON.stringify(this.recurrence))
        this.recurrenceView = true
        this.$emit('getRecurrence', this.recurrence)
      },
      monthDaysLimit (val) {
        if (val > 31) {
          this.recurrence.id_text.days = 31
        }
        if (val < 1) {
          this.recurrence.id_text.days = 31
        }
      },
      deleteAct () {
        this.recurrence.type = ''
        this.recurrence.id_text.days = ''
        this.recurrence.id_text.each = ''
        this.recurrence.id_text.daysToCreate = 1
        this.recurrenceView = false
        this.$emit('getRecurrence', this.recurrence)
        this.$emit('delete')
      },
      // ao trocar de tipo de recorrencia ele já inicia os valores
      changeProcess () {
        if (this.recurrence.type === 'Semanal') {
          this.recurrence.id_text.days = [1, 2, 3, 4, 5]
          this.recurrence.id_text.each = 1
          this.recurrence.id_text.daysToCreate = 1
        } else {
          this.recurrence.id_text.each = 1
          this.recurrence.id_text.days = 1
          this.recurrence.id_text.months = 1
          this.recurrence.id_text.daysToCreate = 1
        }
        this.$emit('getRecurrence', this.recurrence)
      },
      recurrenceConfirm () {
        if (!this.$refs.form.validate()) return
        if (this.recurrence.type === 'Semanal') {
          this.recurText = `Criar toda ${this.recurrence.id_text.days ? this.recurrence.id_text.days : '        '} a cada ${this.recurrence.id_text.each ? this.recurrence.id_text.each : '       '} semanas.`
          this.recurrence.id_text.days.sort((a, b) => {
            return a - b
          })
        }
        this.recurrenceView = false
        this.$emit('getRecurrence', this.recurrence)
        this.$emit('confirm', this.recurrence)
      },
      recurDialogClose () {
        this.recurrence.type = this.beforeRecurOb.type
        this.recurrence.id_text.days = this.beforeRecurOb.id_text.days
        this.recurrence.id_text.each = this.beforeRecurOb.id_text.each
        this.recurrence.id_text.daysToCreate = this.beforeRecurOb.id_text.daysToCreate
        this.recurrenceView = false
        this.$emit('getRecurrence', this.recurrence)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/details/Recurrence.vue